import { AxiosInstance } from 'axios';
import { mapSubgroupsData } from './utils';
import { SubgroupsPoints, Subgroups, Subgroup, Id } from './types';

const getSubgroupsData = (api: AxiosInstance) => ({
  getSubgroups: async (event_id: Id): Promise<Subgroups> => {
    const { data } = await api.get(SubgroupsPoints.GET_SUBGROUPS, {
      params: { event_id },
    });
    return { ...data, data: mapSubgroupsData(data.data) };
  },
});

const getGroupData = (api: AxiosInstance) => ({
  getGroup: async (id: Id): Promise<Subgroup> => {
    const { data } = await api.get(SubgroupsPoints.GET_SUBGROUPS, {
      params: { id },
    });
    return data;
  },
});

const subgroupsService = (api: AxiosInstance) => {
  if (!api) throw new Error('There is no HTTP client');
  return {
    ...getSubgroupsData(api),
    ...getGroupData(api),
  };
};

export default subgroupsService;



// WEBPACK FOOTER //
// ./src/services/subgroups/subgroupsService.ts